import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MonitorOff = createReactComponent("MonitorOff", ["svg", defaultAttributes, [["path", {
  d: "M17 17H4a2 2 0 01-2-2V5c0-1.5 1-2 1-2",
  key: "50l0vr"
}], ["path", {
  d: "M22 15V5a2 2 0 00-2-2H9",
  key: "b9w757"
}], ["path", {
  d: "M8 21h8",
  key: "62csdj"
}], ["path", {
  d: "M12 17v4",
  key: "icnn2j"
}], ["path", {
  d: "M2 2l20 20",
  key: "131xdx"
}]]]);
export default MonitorOff;